<template>
    <div
        class="c-upload"
        :class="[{'c-upload--hover': hover}, {'c-upload--invalid': !valid}]"
        @dragover.prevent=""
        @drop.prevent="">

            <input type="file"
                multiple
                :accept="extensions.join(',')"
                ref="input"
                class="c-upload__input"
                data-silent
                @change="upload"
                @is-valid="valid = true"
                @is-invalid="valid = false"
                :name="name" />

            <div class="c-upload__drop"
                @click="click"
                @dragenter.prevent="hover = true"
                @dragleave.prevent="hover = false"
                @drop.prevent="drop">
                    <div class="c-upload__title">
                        <svg class="color-dark-gray margin-r-4" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9.2935 21c-1.656 0-3.23-.666-4.432-1.875-2.388-2.403-2.486-6.213-.219-8.494l7.386-7.43c.769-.774 1.807-1.201 2.922-1.201 1.193 0 2.327.479 3.192 1.349 1.721 1.731 1.787 4.482.146 6.132l-7.395 7.429c-.479.483-1.124.748-1.816.748-.731 0-1.424-.292-1.95-.821-1.053-1.061-1.086-2.752-.073-3.772l6.825-6.855a.9989.9989 0 0 1 1.414-.004c.391.39.393 1.023.003 1.414l-6.824 6.856c-.24.242-.207.669.074.951.146.147.34.231.531.231.11 0 .268-.027.398-.158l7.395-7.429c.867-.873.802-2.358-.146-3.312-.907-.912-2.446-.984-3.278-.148l-7.386 7.43c-1.494 1.503-1.396 4.049.22 5.674.823.829 1.893 1.285 3.013 1.285 1.001 0 1.929-.378 2.611-1.064l7.387-7.43c.389-.391 1.022-.394 1.414-.004.391.39.393 1.022.004 1.414l-7.387 7.43c-1.06 1.066-2.491 1.654-4.029 1.654" id="attachment"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#attachment"/></svg>
                        <span>{{title}}</span>
                    </div>
                    <div class="c-upload__description">{{extensions.join(', ')}}</div>
            </div>
            <ul v-if="value && value.length > 0 && filelist" class="c-upload__files">
                <li v-for="(file, index) in value">
                    {{file.name}}
                    <button type="button" class="c-btn c-btn--white c-btn--minuscule c-btn--primary no-margin" @click.prevent="remove(index)">
                        <svg class="color-secondary" width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9 11c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm6 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm3 8c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11ZM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328ZM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1Z" id="trash"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#trash"/></svg>
                    </button>
                </li>
            </ul>
            <div class="c-form__error" :class="{'c-form__error--show': !valid}">Dit veld is verplicht.</div>
    </div>
</template>
<script>
export default {
    props: {
        name: {
            type: String,
            required:true
        },
        title: {
            type: String,
            required:true
        },
        extensions: {
            type: Array,
            default: () =>  ['.pdf', '.docx', '.doc', '.png', '.jpg']
        },
        value: {
            required: false,
            default: () => []
        },
        required: {
            type: Boolean,
            default: false
        },
        filelist: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            hover: false,
            valid: true
        }
    },
    methods: {

        click() {
            this.$refs.input.click();
        },

        upload(event) {
            let files = Array.from(event.target.files);

            if ( this.validate(files) ) {
                this.change(this.value.concat(files));
            }
            else {
                this.error();
            }
        },

        drop(event) {
            let files = Array.from(event.dataTransfer.files);

            if ( this.validate(files) ) {
                this.change(this.value.concat(files));
                this.hover = false;
            }
            else {
                this.error();
            }
        },

        change(files) {
            this.$emit('input', files);
            this.$refs.input.value = '';

            this.$nextTick( () => {
                this.valid = this.isFilled(this);
            });
        },

        remove(index) {
            let files = [...this.value];
            files.splice(index, 1);

            this.change(files);
        },

        validate(files) {

            let valid = true;

            files.forEach((file) => {

                let extension = '.'  + file.name.split('.').pop();

                if ( this.extensions.indexOf(extension) < 0 ) {
                    valid = false;
                }
            });

            return valid;
        },

        isFilled(component) {

            return ( !component.required
                    || ( Array.isArray(component.value) && component.value.length )
                );
        },

        error() {
            this.$store.dispatch('toasts/alert', {title: 'Bestandsupload', text: 'Het bestand voldoet niet aan de vereisten'});
        }
    },
    mounted() {
        this.$refs.input.validation = () => {
            return this.isFilled(this);
        };
    }
}
</script>
